import { IGoalsContainerState } from "source/app/presentation/MainPanel/Goals/IGoalsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function GetMatchingGoals(calendarEventName: string) {
    const goalsContainer = State.ReadClass<IGoalsContainerState>(
        ESharedComponent.GoalsContainer
    );

    const matchingGoals = goalsContainer.state.Goals.filter(
        (goal) => !goal.isarchived
    )
        .filter((goal) =>
            goal.name.toLowerCase().includes(calendarEventName.toLowerCase())
        );

    return matchingGoals;
}
